import _ from 'lodash';

class InformationController {
  constructor(Information, Util, growl, $uibModal, Upload, SERVER_URL) {
    "ngInject";

    let vm = this;
    vm.items = [];
    vm.language = "IT";
    vm.summernoteOptions = Util.getSummernoteOptions();
    vm.addItem = addItem;
    vm.saveItem = saveItem;
    vm.deleteItem = deleteItem;
    vm.imageUpload = imageUpload;
    init();

    function init() {
      Information.getList().then(res => {
        vm.items = _.filter(res.data, o => {
          return o.information.active === true
        });
        console.log("Items", vm.items);
      })
    }

    function addItem() {
      $uibModal
      .open({
        component: 'addNew',
        size: 'lg'
      })
      .result
      .then(closed => {
        init();
      })
    }

    function saveItem(itemToSave) {
      Information.putString(itemToSave).then(res => {
        vm.newItem = null;
        growl.success("Sezione modificata con successo");
      }, err => {
        growl.error("Errore modifica sezione");
      })
    }

    function deleteItem(itemToDelete) {
      $uibModal.open({
        component: 'confirmDialog',
        windowClass: 'modal-mini modal-primary',
        resolve: {
          message: () => "Confermi di voler cancellare questa sezione?"
        }
      }).result.then(() => {
        Information.deleteItem(itemToDelete).then(res => {
          growl.success("Sezione cancellata con successo!");
          init();
        }, err => {
          growl.error("Errore cancellazione sezione");
        })
      })
    }
    function imageUpload(images, informationIndex, langIndex) {
      Upload.upload({
        url: SERVER_URL + '/images/public-image',
        data: {
          file: images[0]
        }
      }).then(function (resp) {
        var imgNode = $("<img>").attr('src', resp.data.url)[0];
        var container = $('#summernote-' + langIndex + '-' + informationIndex);
        container.summernote('insertNode', imgNode);
        vm.items[informationIndex].faqstringsList[langIndex].body = container.summernote('code');
        $timeout(function () {
        }, 2000);
      }, function (resp) {
        console.log('Error status: ' + resp.status);
      }, function (evt) {
      });
    }
  }
}

export default InformationController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/information.controller.js